
export class ThongTinDat {
    _id = '';
    price = '';
    name = '';
    image = '';
    proServices='';
    localSellers='';
    onlineSellers='';
    deliveryTime= '';
    status='';
    taiKhoanNguoiDat = '';
}

export class User {
    birthday='';
    name ='';
}

